import React from "react";
import styled from 'styled-components';
import PropTypes from 'prop-types';

const SwiftTextarea = ({
	name,
	value,
	rows,
	onChange,
	error,
	errorStyle,
	style,
	containerStyle,
	containerClassName,
	theme,
	...rest
}) => {
	return (
		<div
			className={containerClassName}
			style={{
				margin: "5px 0",
				padding: '5px',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'flex-start',
				justifyContent: 'flex-start',
				...containerStyle
			}}
		>
			<textarea
				name={name}
				onChange={onChange}
				rows={rows}
				style={{
					padding: "7px",
					width: "100%",
					borderRadius: "5px",
					resize: "none",
					outline: "none",
					color: !!theme && !!theme.text ? theme.text : "black",
					borderColor: !!theme && !!theme.border ? theme.border : "#888",
					backgroundColor: !!theme && !!theme.background ? theme.background : "white",
					...style
				}}
				{...rest}
			>{value}</textarea>
			{!!error && <ErrorFeedback style={{ ...errorStyle }}>{error}</ErrorFeedback>}
		</div>
	);
};

SwiftTextarea.propTypes = {
	name: PropTypes.string,
	value: PropTypes.string,
	rows: PropTypes.string,
	onChange: PropTypes.func,
	error: PropTypes.string,
	errorStyle: PropTypes.object,
	style: PropTypes.object,
	containerStyle: PropTypes.object,
	containerClassName: PropTypes.string,
	placeholder: PropTypes.string,
	theme: PropTypes.object
};

SwiftTextarea.defaultProps = {
	name: '',
	value: '',
	rows: '5',
	onChange: () => console.log('no onChange method attached...'),
	style: {},
	errorStyle: {},
	containerStyle: {},
	containerClassName: "",
};

const ErrorFeedback = styled.span`
	width: 100%;
	margin-top: .25rem;
	font-size: 80%;
	color: red;
	text-align: right;
`;

export default SwiftTextarea;
